<template>
  <div class="skewed-ellips-mask">
    <slot />
  </div>
</template>

<style scoped>
.skewed-ellips-mask {
  mask: url('../../../../assets/masks/q_skewed_ellips.svg');
  mask-size: 100%;
  mask-repeat: no-repeat;
  mask-position: center;
}
</style>
